import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Discussion from 'flarum/common/models/Discussion';
import Badge from 'flarum/common/components/Badge';

export default function addFeatureBadge() {
  extend(Discussion.prototype, 'badges', function (badges) {
    if (this.attribute('isFeatured')) {
      badges.add('featured', <Badge
        type="featured"
        label={app.translator.trans('tanka-connector.forum.badge.featured_tooltip')}
        icon={app.forum.attribute('tanka-connector.featuredIcon') || 'fas fa-magic'}
      />);
    }
  });
}
